<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('reclamation-header') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-if="debt.debtSummary.state.state === 4">
      <v-row justify="center">
        <v-col class="shrink">
          <v-icon :size="100" color="color-red">
            fas fa-exclamation-triangle
          </v-icon>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="text-center">
          <h3 class="mt-4 text-h3">{{ $t('reclamation-summons') }}</h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="10" v-html="$t('reclamation-summons-html')"></v-col>
      </v-row>
      <v-row justify="center">
        <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$emit('close')">
          <span>{{ $t('close') }}</span>
        </v-btn>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-if="debt.debtSummary.state.state === 12">
      <v-row justify="center">
        <v-col class="shrink">
          <v-icon :size="100" color="color-green">
            fas fa-info-circle
          </v-icon>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="text-center">
          <h3 class="mt-4 text-h3">{{ $t('reclamation-existing') }}</h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="10">
          <p>{{ $t('reclamation-existing-desc-1') }}</p>
          <p>{{ $t('reclamation-existing-desc-2') }}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$emit('close')">
          <span>{{ $t('close') }}</span>
        </v-btn>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-if="step === 0 && debt.debtSummary.state.state !== 12 && debt.debtSummary.state.state !== 4">
      <v-row no-gutters>
        <v-col>
          <v-container class="pa-0" fluid>
            <v-row justify="center">
              <v-col cols="12" sm="10" class="text-center">
                <h3 class="text-h3 mt-0" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('reclamation-header') }}</h3>
              </v-col>
              <v-col cols="12" sm="10">
                <p>{{ $t('reclamation-desc-1') }}</p>
                <p>{{ $t('reclamation-desc-2') }}</p>
              </v-col>
            </v-row>
            <v-row justify="center" class="mb-4">
              <div class="pa-3">
                <v-btn tile class="primary wide-button" @click="step = 2">
                  {{ $t('reclamation-start') }}
                </v-btn>
              </div>
              <div class="pa-3">
                <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$emit('close')">
                  <span>{{ $t('cancel') }}</span>
                </v-btn>
              </div>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-if="step > 0 && debt.debtSummary.state.state !== 12 && debt.debtSummary.state.state !== 4">
      <v-container class="pa-0" fluid>
        <v-row justify="center">
          <h3 class="mt-0 text-h3" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('reclamation-header') }}</h3>
        </v-row>
        <v-row no-gutters justify="center">
          <v-col cols="12" sm="10">
            <v-row justify="center">
              <v-col cols="12" sm="3">
                <p class="ok-title">{{ $t('debt') }}</p>
                <p class="ok-subtitle small" data-matomo-mask>{{ debt.orderNr }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <p class="ok-title">{{ $t('creditor') }}</p>
                <p class="ok-subtitle small">{{ debt.creditor.name }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-stepper v-model="step" class="elevation-0">
        <v-row no-gutters justify="center">
          <v-col cols="12" sm="6">
            <v-stepper-header class="elevation-0" v-if="bills.length > 1">
              <v-stepper-step complete step="0" />
              <v-divider />
              <v-stepper-step :complete="step > 2" step="2" />
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3" />
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="4" />
            </v-stepper-header>
            <v-stepper-header class="elevation-0" v-else>
              <v-stepper-step complete step="0" />
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2" />
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="3" />
            </v-stepper-header>
          </v-col>
        </v-row>

        <v-stepper-items class="elevation-0">
          <v-stepper-content step="2" class="elevation-0 pa-0" v-if="bills.length > 1">
            <v-row no-gutters v-if="bills.length > 1" justify="center">
              <v-col cols="12">
                <p class="ok-title text-center">{{ $t('reclamation-phase-1') }}</p>
              </v-col>
              <v-col cols="12" sm="8">
                <v-data-table v-model="selectedBills"
                              :headers="headers"
                              :items="bills"
                              item-key="nr"
                              show-select
                              hide-default-footer
                              :items-per-page="-1"
                              :mobile-breakpoint="0"
                              data-matomo-mask>
                  <template #item.dueDate="{ item }">
                    {{ item.dueDate | formatDate }}
                  </template>
                  <template #item.total="{ item }">
                    {{ item.total | currency }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-6">
              <div class="pa-3">
                <v-btn tile class="primary wide-button" @click="step = 3" :disabled="selectedBills.length === 0">
                  {{ $t('continue') }}
                </v-btn>
              </div>
              <div class="pa-3">
                <v-btn tile outlined color="color-grey" class="wide-button" @click="$emit('close')">
                  <span>{{ $t('cancel') }}</span>
                </v-btn>
              </div>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="bills.length > 1 ? 3 : 2" class="elevation-0 pa-0">
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <h4 class="text-center ma-0 text-h4">{{ $t('reclamation-basis') }}</h4>
              </v-col>
              <v-col cols="12">
                <v-row class="justify-center">
                  <div :class="{ 'pa-3': $vuetify.breakpoint.mdAndUp, 'col-12 py-0': $vuetify.breakpoint.smAndDown }">
                    <v-checkbox v-model="reclamationBasis" :label="$t('reclamation-basis-1')" value="Laskun sisältö"></v-checkbox>
                  </div>
                  <div :class="{ 'pa-3': $vuetify.breakpoint.mdAndUp, 'col-12 py-0': $vuetify.breakpoint.smAndDown }">
                    <v-checkbox v-model="reclamationBasis" :label="$t('reclamation-basis-2')" value="Laskun peruste"></v-checkbox>
                  </div>
                  <div :class="{ 'pa-3': $vuetify.breakpoint.mdAndUp, 'col-12 py-0': $vuetify.breakpoint.smAndDown }">
                    <v-checkbox v-model="reclamationBasis" :label="$t('reclamation-basis-3')" value="Perintäkulut"></v-checkbox>
                  </div>
                  <div :class="{ 'pa-3': $vuetify.breakpoint.mdAndUp, 'col-12 py-0': $vuetify.breakpoint.smAndDown }">
                    <v-checkbox v-model="reclamationBasis" :label="$t('reclamation-basis-4')" value="Muu syy"></v-checkbox>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center">
              <v-col cols="12" sm="10">
                <h4 class="text-center mt-0 text-h4">{{ $t('reclamation-info') }}</h4>
                <p class="text-center">{{ $t('reclamation-info-desc') }}</p>
              </v-col>
              <v-col cols="12" sm="10" v-cloak @drop.prevent="addDropFile" @dragover.prevent>
                <v-row class="justify-center">
                  <v-col cols="12">
                    <p class="ok-title">{{ $t('reclamation-text') }} *</p>
                    <v-textarea v-model="text"
                                @blur="$v.text.$touch()"
                                @change="$v.text.$touch()"
                                :error-messages="textError"
                                outlined
                                auto-grow
                                :counter="1000">
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p class="ok-title">{{ $t('reclamation-name') }} *</p>
                    <v-text-field outlined
                                  v-model="name"
                                  @blur="$v.name.$touch()"
                                  @change="$v.name.$touch()"
                                  :error-messages="nameError"
                                  :counter="50">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p class="ok-title">{{ $t('reclamation-email') }} *</p>
                    <v-text-field outlined
                                  v-model="email"
                                  @blur="$v.email.$touch()"
                                  @change="$v.email.$touch()"
                                  :error-messages="emailError"
                                  :counter="50">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <p class="ok-title">{{ $t('reclamation-phone') }}</p>
                    <v-text-field name="phone"
                                  prefix="+358"
                                  class="long-prefix"
                                  outlined
                                  id="phone"
                                  @blur="$v.phone.$touch()"
                                  v-model="phone"
                                  :error-messages="phoneError"
                                  :counter="12">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p class="ok-title">{{ $t('reclamation-attachments') }}</p>
                    <v-file-input v-model="files"
                                  :error-messages="fileErrors"
                                  @blur="$v.files.$touch()"
                                  multiple
                                  prepend-inner-icon="fas fa-paperclip"
                                  prepend-icon=""
                                  outlined
                                  :accept="fileTypes"
                                  :show-size="1000">
                      <template v-slot:selection="{ index, text }">
                        <v-chip v-if="index < 2"
                                color="primary"
                                dark
                                label
                                small>
                          {{ text }}
                        </v-chip>
                        <span v-else-if="index === 2" class="mx-2">
                          +{{ files.length - 2 }} {{ $t('reclamation-attachment') }}
                        </span>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center">
              <div class="pa-3">
                <v-btn tile class="primary wide-button" @click="requestReclamation" :loading="loading" :disabled="!isValid || loading">
                  {{ $t('reclamation-confirm') }}
                </v-btn>
              </div>
              <div class="pa-3">
                <v-btn tile class="secondary wide-button" @click="step = 2" v-if="bills.length > 1">
                  {{ $t('back') }}
                </v-btn>
              </div>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="bills.length > 1 ? 4 : 3" class="elevation-0 pa-0">
            <v-row no-gutters justify="center">
              <div class="pa-3">
                <v-icon :size="100" color="color-green">
                  fa-check
                </v-icon>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h3 class="mt-4 text-h3 text-center">{{ $t('reclamation-done') }}</h3>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <p class="text-center">{{ $t('reclamation-done-desc') }}</p>
              </v-col>
            </v-row>
            <v-row justify="center" class="text-center">
              <shared-customer-feedback :orderNr="debt.nr" :type="5" @close="$emit('close')"></shared-customer-feedback>
            </v-row>
            <v-row justify="center">
              <div class="pa-3">
                <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$store.commit('setReclamationRequested', { DebtNr: debt.orderNr }); $emit('close')">
                  <span>{{ $t('close') }}</span>
                </v-btn>
              </div>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-card>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

  const allowedFiletypes = ['.pdf', '.rtf', '.doc', '.docx', '.xls', '.xlsx', '.msg', '.jpg', '.png', '.bmp', '.tiff', '.jpeg']

  const fileSize = function (value) {
    var totalSize = 0
    for (var i = 0; i < value.length; i++) {
      totalSize += value[i].size
    }
    return totalSize <= 20000000
  }

  const fileTypes = function (value) {
    for (var i = 0; i < value.length; i++) {
      let fileType = value[i].name.substring(value[i].name.lastIndexOf('.'))
      console.log(fileType)
      if (allowedFiletypes.indexOf(fileType) < 0) {
        return false
      }
    }

    return true
  }

  export default {
    props: ['debt'],
    data: function () {
      return {
        step: 0,
        selectedBills: [],
        reclamationBasis: [],
        text: '',
        name: '',
        email: '',
        phone: '',
        files: [],
        fileTypes: allowedFiletypes
      }
    },
    watch: {
      selectedBills: function () {
        if (this.selected.length > 0) {
          this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Select")
        }
      },
      reclamationBasis: function () {
        if (this.selected.length > 0) {
          this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Form")
        }
      }
    },
    mounted () {
      if (this.debt.debtSummary.state.state === 12) {
        this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation In Progress")
      }
    },
    computed: {
      bills () {
        return this.debt.bills.filter(function (bill) {
          return bill.type === 1
        })
      },
      headers () {
        let desktopHeaders = [
          { text: this.$t('dueDate'), value: 'dueDate' },
          { text: this.$t('debtAmount'), value: 'total' },
          { text: this.$t('billNr'), value: 'referenceNr' }
        ]

        return desktopHeaders
      },
      loading () {
        return this.$store.getters.loading
      },
      isValid () {
        if (this.reclamationBasis.length > 0 &&
          (!this.$v.text.$error && this.$v.text.$dirty) &&
          (!this.$v.name.$error && this.$v.name.$dirty) &&
          (!this.$v.email.$error && this.$v.email.$dirty) &&
          !this.$v.phone.$error &&
          !this.$v.files.$error) {
          if (this.selectedBills.length > 0 || this.bills.length === 1) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      textError () {
        const errors = []
        if (!this.$v.text.$dirty) return errors
        !this.$v.text.required && errors.push(this.$t('textErrors.required'))
        !this.$v.text.minLength && errors.push(this.$t('textErrors.length'))
        !this.$v.text.maxLength && errors.push(this.$t('textErrors.length'))
        return errors
      },
      nameError () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.required && errors.push(this.$t('nameErrors.required'))
        !this.$v.name.maxLength && errors.push(this.$t('nameErrors.length'))
        return errors
      },
      emailError () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.required && errors.push(this.$t('validation.email.required'))
        !this.$v.email.email && errors.push(this.$t('validation.email.email'))
        !this.$v.email.maxLength && errors.push(this.$t('validation.email.length'))
        return errors
      },
      phoneError () {
        const errors = []
        if (!this.$v.phone.$dirty) return errors
        !this.$v.phone.numeric && errors.push(this.$t('phoneNrErrors.numeric'))
        !this.$v.phone.minLength && errors.push(this.$t('phoneNrErrors.length'))
        !this.$v.phone.maxLength && errors.push(this.$t('phoneNrErrors.length'))
        return errors
      },
      fileErrors () {
        const errors = []
        if (!this.$v.files.$dirty) return errors
        !this.$v.files.fileSize && errors.push(this.$t('fileSizeError'))
        !this.$v.files.fileTypes && errors.push(this.$t('fileTypesError'))
        return errors
      }
    },
    methods: {
      addDropFile(e) {
        this.files.push(...Array.from(e.dataTransfer.files))
      },
      requestReclamation () {
        if (this.isValid) {
          this.$store.commit('setLoading', true)
          this.transferedDueDate = null
          let billNrs = this.bills.length === 1 ? this.bills.map(function (b) { return b.nr }) : this.selectedBills.map(function (b) { return b.nr })

          var formData = new FormData();
          formData.append('orderNr', this.debt.nr)
          formData.append('basis', this.reclamationBasis)
          formData.append('text', this.text)
          formData.append('name', this.name)
          formData.append('phone', this.phone)
          formData.append('email', this.email)

          billNrs.forEach(billNr => {
            formData.append('billNrs', billNr)
          })

          this.files.forEach(file => {
            formData.append('files', file)
          })

          apiResource.post('api/orders/reclamationRequest', formData).then((response) => {
            this.$store.commit('setLoading', false)

            if (response.data.status === 0) {
              if (response.data.responseObject === true) {
                this.step = this.bills.length > 1 ? 4 : 3
                this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Sent")
              } else {
                this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
                this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Failed")
              }
            } else {
              this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
              this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Failed")
            }
          }).catch((errorResponse) => {
            this.$store.commit('setLoading', false)
            this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
            this.$matomo && this.$matomo.trackEvent("Action", "Make Reclamation", "Reclamation Failed")
          })
        }
      }
    },
    validations: {
      text: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(1000)
      },
      name: {
        required,
        maxLength: maxLength(50)
      },
      email: {
        required,
        email,
        maxLength: maxLength(50)
      },
      phone: {
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(12)
      },
      files: {
        fileSize,
        fileTypes
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "reclamation-header": "Reklamaatio",
  "reclamation-desc-1": "Voit tehdä meille reklamaation saamasi laskun sisällöstä, tai perintään liittyvästä toimenpiteestä, joka on mielestäsi virheellinen.",
  "reclamation-desc-2": "Olemme sinuun tarvittaessa yhteydessä reklamaation käsittelyn aikana.",
  "reclamation-phase-1": "Valitse yksi tai useampi lasku, josta haluat reklamoida",
  "reclamation-confirm": "Lähetä reklamaatio",
  "reclamation-start": "Aloita",
  "reclamation-existing": "Reklamaatiota käsitellään",
  "reclamation-existing-desc-1": "Tästä asiasta on jo tehty reklamaatio, jonka käsittely on kesken.",
  "reclamation-existing-desc-2": "Olemme tarvittaessa sinuun yhteydessä reklamaation käsittelyn aikana.",
  "reclamation-basis": "Kerro reklamaation syy",
  "reclamation-basis-1": "Laskun sisältö tai summa",
  "reclamation-basis-2": "Laskun peruste",
  "reclamation-basis-3": "Perintäkulut",
  "reclamation-basis-4": "Muu syy",
  "reclamation-info": "Reklamaation saate ja yhteystiedot",
  "reclamation-info-desc": "Tähdellä merkityt kentät ovat pakollisia.",
  "reclamation-text": "Saate",
  "reclamation-name": "Nimi",
  "reclamation-email": "Sähköpostiosoite",
  "reclamation-phone": "Puhelinnumero",
  "reclamation-attachments": "Liitetiedostot",
  "reclamation-attachment": "tiedosto(a)",
  "reclamation-done": "Reklamaatio vastaanotettu",
  "reclamation-done-desc": "Velan käsittely on pysäytetty. Reklamaation käsittelyn edetessä olemme sinuun yhteydessä tarpeen mukaan.",
  "reclamation-summons": "Asia on haastettu",
  "reclamation-summons-html": "<p>Olemme tehneet tästä asiasta haastehakemuksen käräjäoikeuteen. Tämän vuoksi reklamaatiota meille ei voi enää tehdä, vaan mahdolliset riitautukset asiaa koskien on tehtävä käräjäoikeudelle.</p><p>Olethan yhteydessä käräjäoikeuteen viimeistään silloin, kun saat haasteesta tiedoksiannon.</p><a class=\"font-weight-bold\" href=\"https://oikeus.fi/tuomioistuimet/karajaoikeudet/fi/index/yhteystiedot.html\" target=\"_blank\">Käräjäoikeuksien yhteystiedot</a>",
  "phoneNrErrors": {
  "required": "Syötä puhelinnumero",
  "numeric": "Puhelinnumeron tulee olla numero",
  "length": "Puhelinnumeron tulee olla 1-12 numeroa pitkä"
  },
  "textErrors": {
  "required": "Syötä saate",
  "length": "Saatteen tulee olla 10-1000 merkkiä pitkä"
  },
  "nameErrors": {
  "required": "Syötä nimi",
  "length": "Nimi on liian pitkä"
  },
  "fileSizeError": "Liiteiden koko on liian iso",
  "fileTypesError": "Tiedostotyyppi ei ole sallittu"
  },
  "se": {
  "reclamation-header": "Reklamation",
  "reclamation-desc-1": "Du kan reklamera fakturans innehåll eller dess indrivning ifall det enligt dig finns felaktigheter.",
  "reclamation-desc-2": "Vi kontaktar dig vid behov då reklamationen behandlas.",
  "reclamation-phase-1": "Välj en eller flera fakturor som du vill reklamera",
  "reclamation-confirm": "Sänd reklamation",
  "reclamation-start": "Reklamera",
  "reclamation-existing": "Reklamationen behandlas",
  "reclamation-existing-desc-1": "Detta ärende har redan reklamerats och reklamationen är under behandling.",
  "reclamation-existing-desc-2": "Vi kontaktar dig vid behov.",
  "reclamation-basis": "Välj orsak till reklamationen",
  "reclamation-basis-1": "Fakturans innehåll eller summa",
  "reclamation-basis-2": "Fakturans grund",
  "reclamation-basis-3": "Indrivningskostnader",
  "reclamation-basis-4": "Annan orsak",
  "reclamation-info": "Förklaring till reklamationen och kontaktuppgifter",
  "reclamation-info-desc": "Fält märkta med en stjärna är obligatoriska.",
  "reclamation-text": "Förklaring",
  "reclamation-name": "Namn",
  "reclamation-email": "E-postadress",
  "reclamation-phone": "Telefonnummer",
  "reclamation-attachments": "Bilagor",
  "reclamation-attachment": "fil(er)",
  "reclamation-done": "Reklamationen har mottagits",
  "reclamation-done-desc": "Handläggningen av fordran stoppas medan reklamationen behandlas. Vi kontaktar dig vid behov.",
  "reclamation-summons": "Ärendet är stämt",
  "reclamation-summons-html": "<p>Vi har I detta ärende gjort en stämningsansökan som skickats till tingsrätten. Vi tar därför inte emot reklamationer utan eventuella stridigheter skall meddelas direkt till tingsrätten.</p><p>Tag senast kontakt med tingsrätten då du blir delgiven stämning.</p><a class=\"font-weight-bold\" href=\"https://oikeus.fi/tuomioistuimet/karajaoikeudet/sv/index/yhteystiedot.html\" target=\"_blank\">Tingsrätternas kontaktuppgifter</a>",
  "phoneNrErrors": {
  "required": "Telefonnummer är obligatoriskt",
  "numeric": "Telefonnummer bör vara numeriskt",
  "length": "Telefonnummer bör vara mellan 8-9 tecken"
  },
  "textErrors": {
  "required": "Fyll i förklaring",
  "length": "Förklaring bör vara mellan 10-1000 tecken"
  },
  "nameErrors": {
  "required": "Fyll i namn",
  "length": "Namn är för lång"
  },
  "fileSizeError": "Bilagan är för stor",
  "fileTypesError": "Denna filtyp tillåts inte"
  },
  "en": {
  "reclamation-header": "Complaint",
  "reclamation-desc-1": "You can file a complaint to us regarding your invoice or the collection process and related fees.",
  "reclamation-desc-2": "We will contact you for more information during the process if necessary.",
  "reclamation-phase-1": "Select one or more invoices for basis of complaint",
  "reclamation-confirm": "Submit complaint",
  "reclamation-start": "Start",
  "reclamation-existing": "Complaint is under review",
  "reclamation-existing-desc-1": "A complaint has already been filed regarding this debt.",
  "reclamation-existing-desc-2": "We will contact you for more information if needed.",
  "reclamation-basis": "Reason for the complaint",
  "reclamation-basis-1": "Invoice content or sum",
  "reclamation-basis-2": "Basis of the Invoice",
  "reclamation-basis-3": "Collection costs",
  "reclamation-basis-4": "Other reason",
  "reclamation-info": "Description of the complaint",
  "reclamation-info-desc": "Fields marked with an asterisk are mandatory.",
  "reclamation-text": "Description",
  "reclamation-name": "Name",
  "reclamation-email": "E-mail address",
  "reclamation-phone": "Phone number",
  "reclamation-attachments": "Attachments",
  "reclamation-attachment": "file(s)",
  "reclamation-done": "We have received your complaint",
  "reclamation-done-desc": "We have paused the collection process. We will contact you for more information if needed.",
  "reclamation-summons": "An application for a summons has been filed",
  "reclamation-summons-html": "<p>We have filed an application for a summons to the court regarding this debt, and as a result a complaint can no longer be filed with us. To dispute the application for a summons, you must contact the relevant district court.</p><p>Please contact the court at the latest when you receive the application for a summons.</p><a class=\"font-weight-bold\" href=\"https://oikeus.fi/tuomioistuimet/karajaoikeudet/en/index/yhteystiedot.html\" target=\"_blank\">District Court Contact Information</a>",
  "phoneNrErrors": {
  "required": "Phone number is mandatory",
  "numeric": "Phone number must be numeric",
  "length": "Phone number must be between 8-9 numbers long"
  },
  "textErrors": {
  "required": "Fill in description",
  "length": "Description must be between 10-1000 characters"
  },
  "nameErrors": {
  "required": "Name is required",
  "length": "Name is too long"
  },
  "fileSizeError": "Attachment size too big",
  "fileTypesError": "File type is not allowed"
  }
  }
</i18n>

<style>
  .v-stepper__step--active:not(.v-stepper__step--complete) > span.v-stepper__step__step {
    background: #3eb1c8 !important;
  }
</style>
